import { render, staticRenderFns } from "./forexDemoAcounts.vue?vue&type=template&id=2c2001b0&scoped=true"
import script from "./forexDemoAcounts.vue?vue&type=script&lang=js"
export * from "./forexDemoAcounts.vue?vue&type=script&lang=js"
import style0 from "./forexDemoAcounts.vue?vue&type=style&index=0&id=2c2001b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2001b0",
  null
  
)

export default component.exports